<template>
    <div>
        <Select2
            :required="true"
            :name="school_name"
            v-model="myValue"
            :options="myOptions"
            :settings="{
                width: '100%',
                placeholder: 'Please enter school name or postcode',
                minimumInputLength: 3,
                ajax: {
                    delay: 250,
                    url: '/api/getSchools',
                    dataType: 'json',
                    cache: true,
                },
            }"
            @select="mySelectEvent($event)"
        />
    </div>
</template>

<script>
import Select2 from 'vue3-select2-component';

export default {
    components: { Select2 },
    data() {
        return {
            school_name: 'school_name',
            myValue: '',
            myOptions: [
                {
                    id: -1,
                    text: 'school',
                    text2: 'postcode',
                },
            ],
        };
    },
    methods: {
        mySelectEvent(event) {
            document.getElementById('school_postcode').value = event.text2;
        },
    },
};
</script>
